import { n as doenetGlobalConfig } from "./doenetml-NmXDuMHr.js";
import { C, D, a, c, b, d, f, g, e, h, i, m, j, r, s, k, l } from "./doenetml-NmXDuMHr.js";
const workerPath = "./doenetml-worker/index.js";
function resolveWorkerUrl() {
  try {
    return new URL(workerPath, import.meta.url).href;
  } catch {
  }
  try {
    return new URL("/doenetml-worker/index.js", document.baseURI).href;
  } catch {
    return null;
  }
}
function isSameOrigin(url) {
  try {
    const u = new URL(url, self.location.href);
    if (u.protocol === "blob:" || u.protocol === "data:") {
      return true;
    }
    return u.origin === self.location.origin;
  } catch {
    return true;
  }
}
try {
  const workerUrl = resolveWorkerUrl();
  if (workerUrl !== null) {
    if (isSameOrigin(workerUrl)) {
      doenetGlobalConfig.doenetWorkerUrl = workerUrl;
    } else {
      const bootstrap = `importScripts(${JSON.stringify(workerUrl)});`;
      doenetGlobalConfig.doenetWorkerUrl = URL.createObjectURL(
        new Blob([bootstrap], { type: "text/javascript" })
      );
    }
  }
} catch (e2) {
  console.warn("Unable to resolve external DoenetML worker URL:", e2);
}
export {
  C as CodeMirror,
  D as DoenetEditor,
  a as DoenetViewer,
  c as cidFromText,
  b as creativeCommonsVersions,
  d as defaultCreativeCommonsVersion,
  f as fetchLocaleLoaders,
  g as getMediaLicenseDisplay,
  e as getMediaLicenseInfo,
  h as getStylePalette,
  i as getStylePalettes,
  m as mathjaxConfig,
  j as mediaLicenses,
  r as retrieveTextFileForCid,
  s as serializedComponentsReplacer,
  k as serializedComponentsReviver,
  l as setLocaleLoaders
};
